import { Component, DoCheck } from '@angular/core';
import { SidebarServiceService } from '../../services/sidebar-service.service';
import { AngularMaterialModule } from '../../angular-material.module';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AddMembersComponent } from '../../Modules/Members/add-members/add-members.component';
import { MatDialog } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { JoinSocietyComponent } from '../../Modules/join-society/join-society.component';
import { canAccessDashboard } from '../../core/auth/role-navigation';

// Typed model for sidebar items for a clean, nested JSON-like config
interface SidebarItem {
  label: string;
  iconName: string;
  route?: string | null;
  permission?: string | null;
  // Tooltip text used in some items
  matTooltip?: string | null;
  // Whether the item is disabled (always provided in our config)
  disable: boolean;
  // Optional custom click action
  action?: string | null;
  // Optional nested children for grouped menus
  children?: SidebarItem[];
}

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [AngularMaterialModule , CommonModule,RouterModule, FormsModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements DoCheck {
  constructor(public sidebarStateService: SidebarServiceService, private dialog: MatDialog) {}
  roleId = sessionStorage.getItem('role_id');
  roleName = sessionStorage.getItem('role_name');
  menuItems: SidebarItem[] = [];
  private lastSearchText = '';
  private lastRoleId: string | null = null;
  private lastAccountGroupId: string | null = null;

  toggleSidebar() {
    this.sidebarStateService.toggleSidebar();
  }


  storageUrl = environment.storageUrl;
  permissionData = sessionStorage.getItem('permission_id');

  LogoUrl =
    sessionStorage.getItem('logo') !== ''
      ? this.storageUrl + '/' + sessionStorage.getItem('logo')
      : null;
  accountDisplayName = sessionStorage.getItem('account_display_name');

   hasPermission(permission: string | null | undefined): boolean {
    if (!permission) {
      return true;
    }

    if (!this.permissionData) {
      return false;
    }

    return this.permissionData.includes(permission);
  }

  // handleTippy(hoverTargetId: string) {
  //   if (this.sidebarStateService.getSidebarState()) return;

  //   const hoverElement = document.getElementById(hoverTargetId);

  //   const instance = tippy(hoverElement!);

  //   const menuBlockID = hoverTargetId.concat('-menu');
  //   const menuBlock = document.getElementById(menuBlockID);
  //   if (menuBlock !== null) {
  //     menuBlock.style.display = 'block';
  //   }
  //   instance.setContent(menuBlock!);

  //   instance.setProps({
  //     allowHTML: true,
  //     interactive: true,
  //     duration: 100,
  //     offset: [0, 5],
  //     placement: 'right-start',
  //     popperOptions: {
  //       modifiers: [
  //         {
  //           name: 'flip',
  //           options: {
  //             fallbackPlacements: ['right', 'right-end'],
  //           },
  //         },
  //       ],
  //     },
  //   });

  //   instance.show();
  // }

  sideMenuSingleIcon: SidebarItem[] = [
  {
    label: 'Home',
    matTooltip: 'Home',
    iconName: 'home',
    route: '/dashboard',
    disable: false,
    permission: null
  },
  {
    label: 'Requests',
    matTooltip: 'Requests',
    iconName: 'assignment',
    route: null,
    disable: false,
    permission: null,
    children: [
      {
        label: 'All Requests',
        matTooltip: 'All Requests',
        iconName: 'assignment',
        route: '/all-requests',
        disable: false,
        permission: null
      },
      {
        label: 'My Requests',
        matTooltip: 'My Requests',
        iconName: 'person',
        route: '/my-requests',
        disable: false,
        permission: null
      },
      {
        label: 'Request Dashboard',
        matTooltip: 'Request Dashboard',
        iconName: 'dashboard',
        route: '/request-dashboard',
        disable: false,
        permission: null
      }
    ]
  },
  {
    label: 'Access Verification',
    matTooltip: 'Access Verification',
    iconName: 'verified_user',
    route: '/access-verification',
    disable: false,
    permission: null,
    children: [
      {
        label: 'Verification Requests',
        matTooltip: 'Verification Requests',
        iconName: 'list',
        route: '/access-verification/verification-requests',
        disable: false,
        permission: null
      },
      {
        label: 'Customer Signup Dashboard',
        matTooltip: 'Customer Signup Dashboard',
        iconName: 'dashboard',
        route: '/access-verification/customer-signup-dashboard',
        disable: false,
        permission: null
      },
      {
        label: 'Assign Projects',
        matTooltip: 'Assign Projects',
        iconName: 'assignment_ind',
        route: '/access-verification/assign-projects',
        disable: false,
        permission: null
      }
    ]
  },
  {
    label: 'My Units',
    matTooltip: 'My Units',
    iconName: 'apartment',
    route: '/my-units',
    disable: false,
    permission: null
  },
// {
//   label: 'Add Members',
//   matTooltip: 'Add Members',
//   iconName: 'person_add',
//   route: null,
//   disable: false,
//   permission: null,
//   action: 'openAddMemberDialog' // <-- custom action key
// },
  {
    label: 'Library',
    matTooltip: 'Library',
    iconName: 'library_books',
    route: '/library',
    disable: false,
    permission: null
  },
  {
    label: 'Society Rules',
    matTooltip: 'Society Rules',
    iconName: 'gavel',
    route: '/society-rules',
    disable: false,
    permission: null
  },
  {
    label: 'Meetings',
    matTooltip: 'Meetings',
    iconName: 'groups',
    route: '/meetings',
    disable: false,
    permission: null
  },
  {
    label: 'Maintenance Management',
    matTooltip: 'Maintenance Management',
    iconName: 'build_circle',
    route: '/maintenance-management',
    disable: false,
    permission: null
  },
  {
    label: 'Appointments',
    matTooltip: 'Appointments',
    iconName: 'event',
    route: null,
    disable: false,
    permission: null,
    children: [
      {
        label: 'Appointments',
        matTooltip: 'Appointments',
        iconName: 'event',
        route: '/appointment',
        disable: false,
        permission: null
      },
      {
        label: 'Appointment Dashboard',
        matTooltip: 'Appointment Dashboard',
        iconName: 'dashboard',
        route: '/appointment/dashboard',
        disable: false,
        permission: null
      }
    ]
  },
   {
      label: 'Society Management',
      iconName: 'business',
       route: null,
      disable: false,
      children: [
        { label: 'Setups', route: '/sop', iconName: 'settings', disable: false },
      ],
    },
    {
      label: 'Asset Management',
      iconName: 'inventory_2',
      route: null,
      disable: false,
      children: [
        { label: 'Assets', route: '/assets-view', iconName: 'inventory_2', disable: false },
        { label: 'Asset Dashboard', route: '/asset-dashboard', iconName: 'dashboard', disable: false },
        { label: 'Assets Summary', route: '/asset-summary', iconName: 'summarize', disable: false },
        { label: 'Asset Movement', route: '/asset-movement', iconName: 'swap_horiz', disable: false },
        { label: 'Asset Movement Approval', route: '/asset-movement-approval', iconName: 'fact_check', disable: false },
        { label: 'Employee Setup', route: '/employee-setup', iconName: 'people', disable: false },
      ],
    },
    {
      label: 'Document Management',
      iconName: 'folder',
       route: null,
      disable: false,
      children: [
        { label: 'TDS Document', route: '/tds-document', iconName: 'description', disable: false },
        { label: 'Society Document', route: '/society-document', iconName: 'description', disable: false },
        { label: 'Agreement Document', route: '/agreement-document', iconName: 'description', disable: false },
        { label: 'Home Loan Document', route: '/home-loan-document', iconName: 'description', disable: false },
      ],
    },
    {
      label: 'Services & Tools',
      iconName: 'build',
       route: null,
      disable: false,
      children: [
        { label: 'Checklist', route: '/checklist-dashboard', iconName: 'checklist', disable: false },
        { label: 'Unit Catalog', route: '/unit-catalog', iconName: 'view_module', disable: false },
        { label: 'Join Society', route: null, iconName: 'group_add', disable: false, action: 'openJoinSocietyDialog' },
        { label: 'Services & Specification', route: '/ordered-specifications', iconName: 'room_service', disable: false },
        { label: 'Utility Management', route: '/utility-management', iconName: 'settings_input_component', disable: false },
      ],
    },
    {
      label: 'Dues',
      iconName: 'monetization_on',
      route: null,
      disable: false,
      children: [
        { label: 'Due Masters', route: '/dues/due-types', iconName: 'category', disable: false },
        { label: 'Bank Details Setup', route: '/dues/bank-details', iconName: 'account_balance', disable: false },
        { label: 'Due Management', route: '/dues/society-dues', iconName: 'account_balance_wallet', disable: false },
        { label: 'Due Assignment', route: '/dues/due-entries', iconName: 'receipt_long', disable: false },
        { label: 'Vendor Payment Setup', route: '/dues/vendor-payment-setup', iconName: 'storefront', disable: false },
        { label: 'Payment History', route: '/dues/payment-history', iconName: 'history', disable: false }
      ]
    },
    {
      label: 'Reminders',
      iconName: 'notifications_active',
      route: null,
      disable: false,
      children: [
        { label: 'Reminder Master', route: '/reminders/reminder-types', iconName: 'category', disable: false },
        { label: 'Reminder Assignment', route: '/reminders/reminder-entries', iconName: 'assignment_turned_in', disable: false }
      ]
    },
    {
      label: 'Account',
      iconName: 'account_circle',
       route: null,
      disable: false,
      children: [
        { label: 'Logout', route: '/logout', iconName: 'logout',disable: false },
      ],
    },
];

hoveredItem: SidebarItem | null = null;
popupTop: number | null = null;
popupBottom: number | null = null;
popupLeft = 0;
private hideFlyoutTimeout?: ReturnType<typeof setTimeout>;

showCollapsedFlyout(item: SidebarItem, element: HTMLElement): void {
  if (this.sidebarStateService.getSidebarState()) {
    return;
  }

  this.clearFlyoutHideTimeout();

  const rect = element.getBoundingClientRect();
  const viewportHeight = window.innerHeight;

  // Estimate height: header is ~65px, each child is ~40px (padding + line height + margin)
  // plus container padding ~16px.
  const estimatedHeight = item.children && item.children.length
    ? Math.min(65 + (item.children.length * 40) + 16, 480)
    : 65;

  if (rect.top + estimatedHeight > viewportHeight) {
    this.popupTop = null;
    this.popupBottom = viewportHeight - rect.bottom;
  } else {
    this.popupTop = rect.top;
    this.popupBottom = null;
  }

  this.popupLeft = rect.right + 8;
  this.hoveredItem = item;
}

scheduleHideCollapsedFlyout(): void {
  this.clearFlyoutHideTimeout();
  this.hideFlyoutTimeout = setTimeout(() => {
    this.hoveredItem = null;
  }, 200);
}

keepCollapsedFlyout(): void {
  this.clearFlyoutHideTimeout();
}

hideCollapsedFlyout(): void {
  this.clearFlyoutHideTimeout();
  this.hoveredItem = null;
}

onCollapsedFlyoutChildClick(event: Event, child: SidebarItem): void {
  this.onCardClick(event, child.disable, child);
  this.hideCollapsedFlyout();
}

onCollapsedSingleItemClick(event: Event, item: SidebarItem): void {
  this.onCardClick(event, item.disable, item);
  this.hideCollapsedFlyout();
}

hasCollapsedChildren(item: SidebarItem | null): boolean {
  return !!item?.children?.length;
}

private clearFlyoutHideTimeout(): void {
  if (this.hideFlyoutTimeout) {
    clearTimeout(this.hideFlyoutTimeout);
    this.hideFlyoutTimeout = undefined;
  }
}


onCardClick(event: Event, disable: boolean, item?: SidebarItem) {
  if (disable) {
    event.preventDefault();
    return;
  }

  if (item?.action === 'openAddMemberDialog') {
    event.preventDefault();
    event.stopPropagation();
    this.dialog.open(AddMembersComponent, { data: {} });
    return;
  }

  if (item?.action === 'openJoinSocietyDialog') {
    event.preventDefault();
    event.stopPropagation();
    this.dialog.open(JoinSocietyComponent, { 
      data: {},
      autoFocus: false,
      restoreFocus: false,
      width: '800px',
      maxWidth: '800px'
    });
    return;
  }
}

  getAccountGroupId(): string | null {
    const direct = sessionStorage.getItem('account_group_id');
    if (direct != null && direct !== '') {
      return String(direct);
    }
    const raw = sessionStorage.getItem('accounts');
    if (raw) {
      try {
        const accounts = JSON.parse(raw);
        if (Array.isArray(accounts) && accounts.length > 0) {
          const accountId = sessionStorage.getItem('account_id');
          const match = accountId ? accounts.find((a: any) => String(a.account_id) === String(accountId)) : null;
          const row = match || accounts[0];
          if (row && row.account_group_id != null) {
            return String(row.account_group_id);
          }
        }
      } catch {}
    }
    return null;
  }

  searchText: string = '';
activeParent: SidebarItem | null = null;

// Automatically close any open submenu when the sidebar is collapsed
ngDoCheck(): void {
  const isExpanded = this.sidebarStateService.getSidebarState();
  if (!isExpanded && this.activeParent) {
    this.activeParent = null;
  }
  if (isExpanded && this.hoveredItem) {
    this.hoveredItem = null;
  }

  // Update menuItems if state changed (memoization to prevent infinite change detection cycles)
  const currentRoleId = sessionStorage.getItem('role_id');
  const currentAccountGroupId = this.getAccountGroupId();
  if (
    this.searchText !== this.lastSearchText ||
    currentRoleId !== this.lastRoleId ||
    currentAccountGroupId !== this.lastAccountGroupId
  ) {
    this.roleId = currentRoleId;
    this.lastSearchText = this.searchText;
    this.lastRoleId = currentRoleId;
    this.lastAccountGroupId = currentAccountGroupId;
    this.updateMenuItems();
  }
}

updateMenuItems(): void {
  this.menuItems = this.getFilteredMenuItems();
}

toggleSubmenu(event: Event, item: SidebarItem) {
  event.preventDefault();
  this.activeParent = this.activeParent === item ? null : item;

  if (item.action === 'openAddMemberDialog') {
    this.dialog.open(AddMembersComponent, { data: {} });
  }

  if (item.action === 'openJoinSocietyDialog') {
    this.dialog.open(JoinSocietyComponent, { 
      data: {},
      autoFocus: false,
      restoreFocus: false,
      width: '800px',
      maxWidth: '800px'
    });
  }
}

// Filter menu items based on search and role permissions
getFilteredMenuItems(): SidebarItem[] {
  let items = this.sideMenuSingleIcon;

  const accountGroupId = this.getAccountGroupId();

  // If account_group_id === '3', only show modules: Home, Requests, Library, Society Rules, Services & Tools, Account
  // And under Society Rules, show only SOP and Category Setup
  if (accountGroupId === '3') {
    const allowedLabels = [
      'Home',
      'Requests',
      'Library',
      'Society Rules',
      'Services & Tools',
      'Account'
    ];

    items = items.filter(item => allowedLabels.includes(item.label));

    items = items.map(item => {
      if (item.label === 'Society Rules') {
        return {
          ...item,
          route: null,
          children: [
            {
              label: 'SOP',
              matTooltip: 'SOP',
              iconName: 'settings',
              route: '/sop',
              disable: false,
              permission: null
            },
            {
              label: 'Category Setup',
              matTooltip: 'Category Setup',
              iconName: 'category',
              route: '/category',
              disable: false,
              permission: null
            }
          ]
        };
      }
      return item;
    });
  }

  const allowedRolesForApproval = ['1', '12', '19'];
  const isAllowedForApproval = allowedRolesForApproval.includes(this.roleId || '');

  // Filter Asset Movement Approval out if the user doesn't have the required role
  items = items.map(item => {
    if (item.label === 'Asset Management' && item.children) {
      return {
        ...item,
        children: item.children.filter(child => {
          if (child.label === 'Asset Movement Approval') {
            return isAllowedForApproval;
          }
          return true;
        })
      };
    }
    return item;
  });

  // Role ID 16: only Asset Management
  if (this.roleId === '16') {
    items = items.filter(item => item.label === 'Asset Management');
  }



  // Role ID 17 (Inspector) filtering: only show 'Requests' and 'Services & Tools' (only 'Checklist' child)
  if (this.roleId === '17') {
    items = items
      .filter(item => item.label === 'Requests' || item.label === 'Services & Tools')
      .map(item => {
        if (item.label === 'Services & Tools' && item.children) {
          return {
            ...item,
            children: item.children.filter(child => child.label === 'Checklist' || child.label === 'Services & Tools')
          };
        }
        return item;
      });
  }

  // Role ID 18 filtering: only show 'Appointments' and 'Requests'
  if (this.roleId === '18') {
    items = items.filter(item => item.label === 'Appointments' || item.label === 'Requests');
  }

  // Role ID 19 (PM/APM/SE / Project Manager) filtering: show only 'Services & Tools' (only 'Checklist' child), 'Requests' ('All Requests' and 'My Requests' children), 'My Units', 'Appointments' ('Appointments' and 'Appointment Dashboard' children), and 'Asset Management'
  if (this.roleId === '19' || this.roleName === 'PM/APM/SE' || this.roleName === 'Project Manager') {
    items = items
      .filter(item => item.label === 'Services & Tools' || item.label === 'Requests' || item.label === 'My Units' || item.label === 'Appointments' || item.label === 'Asset Management')
      .map(item => {
        if (item.label === 'Services & Tools' && item.children) {
          return {
            ...item,
            children: item.children.filter(child => child.label === 'Checklist')
          };
        }
        if (item.label === 'Requests' && item.children) {
          return {
            ...item,
            children: item.children.filter(child => child.label === 'All Requests' || child.label === 'My Requests')
          };
        }
        if (item.label === 'Asset Management' && item.children) {
          return {
            ...item,
            children: item.children.filter(child => child.label === 'Asset Movement Approval')
          };
        }
        return item;
      });
  }

  if (!this.searchText) return items;

  const searchLower = this.searchText.toLowerCase();
  return items.filter(item =>
    item.label.toLowerCase().includes(searchLower) ||
    (item.children && item.children.some(c => c.label.toLowerCase().includes(searchLower)))
  );
}


}
